<template>
  <div>
    <highcharts :options="this.chartOptions" class="cont-chart"></highcharts>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
exportingInit(Highcharts);
import moment from "moment";

export default {
  data() {
    return {
      chartOptions: {
        chart: {
          height: "27%",
        },
        credits: {
          enabled: false,
        },

        colors: ['#2295c8'],
        time: {
          useUTC: true,
        },

        exporting: { enabled: false },
        xAxis: {
          type: "datetime",
          gridLineWidth: 0.1,
          minorGridLineWidth: 1,
        //   lineColor: "grey",
          lineWidth: 1,
          tickWidth: 0,
          labels: {
            enabled: true,
          },
        },
        yAxis: {
          gridLineWidth: 0.5,
          gridLineColor: "rgba(151,151,151,0.5)",
          labels: {
            align: "right",
            x: -3,
            y: 16,
            format: "{value:.,0f}",
          },
          plotLines: [],
        },

        plotOptions: {
          series: {
            lineWidth: 2.5,
            marker: {
              enabled: true,
              radius: 2.5,
            },
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.series.name +
              " : " +
              this.y +
              "</b><br/>" +
              Highcharts.dateFormat("%e %b %Y", new Date(this.x))
            );
          },
        },
        series: [
          {
            name: this.caseConversion(this.param),
            type: "line",
            allowPointSelect: true,
            data: [],
            // pointStart: moment(new Date(this.value)).format("DD MMM hh:mm A"),
            // pointInterval: 24, //* 3600 * 1000,  one day
            pointPadding: 0,
            groupPadding: 0.1,
            showInLegend: false,
          },
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chart: {
                className: "small-chart",
              },
            },
          ],
        },
      },
      lineCol: [],
    };
  },
  props: ["data", "param"],
  methods: {
    caseConversion(str) {
      // adding space between strings
      const result = str.replace(/([A-Z])/g, " $1");
      // converting first character to uppercase and join it to the final string
      const final = result.charAt(0).toUpperCase() + result.slice(1);
      return final;
    },
    colorCode(param) {
      if (param === "total") {
        this.lineCol = ["#e91e63"];
      } else if (param === "air") {
        this.lineCol = ["#3f51b5"];
      } else if (param === "pollen") {
        this.lineCol = ["#28a745"];
      } else if (param === "weather") {
        this.lineCol = ["#a13764"];
      } else if (param === "soil") {
        this.lineCol = ["#743d2b"];
      } else if (param === "water") {
        this.lineCol = ["#2295c8"];
      } else if (param === "fire") {
        this.lineCol = ["#ffb347"];
      }
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(v) {
        if (v) 
        {
        this.chartOptions.series[0].data = v;
        this.chartOptions.title = this.caseConversion(this.param);
        }
      },
    },
    param: {
      immediate: true,
      handler(v) {
        this.colorCode(v)
        this.chartOptions.series[0].name = this.caseConversion(this.param);
      },
    },
  },
};
</script>

<style>
</style>